import React from 'react'
import { graphql } from 'gatsby'
import { Helmet } from 'react-helmet'

// components
import Heading from '../components/atoms/BaseHeading'
import Breadcrumb from '../components/molecules/Breadcrumb'
import DetailContents from '../components/molecules/DetailContents'
import Layout from '../components/templates/Default'

// template
const detailFaq = (props) => {
  const post = props.data.currentPost
  const catOne = props.data.currentCatOne
  const catTwo = props.data.currentCatTwo

  return (
    <Layout catOne={catOne.frontmatter.cat} catTwo={catTwo.frontmatter.cat}>
      <Helmet>
        <html lang="ja" />
        <meta charSet="utf-8" />
        <meta http-equiv="Pragma" content="no-cache" />
        <meta http-equiv="Cache-Control" content="no-cache" />
        <meta http-equiv="Expires" content="0" />
        <title>
          {post.frontmatter.title}｜{catTwo.frontmatter.title}｜
          {catOne.frontmatter.title}｜ヘルプ
        </title>
        <link
          rel="stylesheet"
          href="https://use.fontawesome.com/releases/v5.8.1/css/all.css"
          integrity="sha384-50oBUHEmvpQ+1lW4y57PTFmhCaXp0ML5d60M1M7uH2+nqUivzIebhndOJK28anvf"
          crossorigin="anonymous"
        />
      </Helmet>

      <Breadcrumb
        breadcrumb={[
          { id: 1, name: catOne.frontmatter.title, link: catOne.fields.slug },
          { id: 2, name: catTwo.frontmatter.title, link: catTwo.fields.slug },
        ]}
      />

      <section>
        <Heading level={1} className="title-detail">
          {post.frontmatter.title}
        </Heading>
        <DetailContents detailContents={{ __html: post.html }} />
      </section>
    </Layout>
  )
}

export default detailFaq

// script
export const query = graphql`
  query($slug: String, $catOne: String, $catTwo: String, $catTwoSlug: String) {
    currentPost: markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      frontmatter {
        kind
        posttype
        cat
        order
        title
        date
      }
    }
    currentCatOne: markdownRemark(
      frontmatter: {
        kind: { eq: "faq" }
        posttype: { eq: "catOne" }
        cat: { eq: $catOne }
      }
    ) {
      id
      fields {
        slug
      }
      frontmatter {
        kind
        posttype
        cat
        order
        title
        date
      }
    }
    currentCatTwo: markdownRemark(
      fields: { slug: { eq: $catTwoSlug } }
      frontmatter: {
        kind: { eq: "faq" }
        posttype: { eq: "catTwo" }
        cat: { eq: $catTwo }
      }
    ) {
      id
      fields {
        slug
      }
      frontmatter {
        kind
        posttype
        cat
        order
        title
        date
      }
    }
  }
`
